import React, {Component} from 'react';
import styles from './PlaceCard.module.css';
import ProgressiveImage from 'react-progressive-image';

class PlaceCard extends Component {

    constructor(props){
        super(props);

        this.renderImage = this.renderImage.bind(this);
    }

    renderDistance() {
        if(this.props.cardInfo.distance){
            let unit = "km";
            let distance = this.props.cardInfo.distance;

            if(distance < 1){
                distance = distance * 1000;
                unit = "m";
            }

            return distance.toFixed(0) + ' ' + unit;
        }
    }

    renderImage(){
        if(this.props.cardInfo){
            if(this.props.resize){
                let url = this.props.cardInfo.imgs[0].replace("images", "images/" + this.props.resize);
                return (
                    <ProgressiveImage src={url} placeholder={url}>
                        {(src, loading) => <img src={src} alt="an image" style={{ opacity: loading ? 0 : 1 }} />}
                    </ProgressiveImage>
                );
            }else{
                let url = this.props.cardInfo.imgs[0];
                return (
                    <ProgressiveImage src={url} placeholder={url}>
                        {(src, loading) => <img src={src} alt="an image" style={{ opacity: loading ? 0 : 1 }} />}
                    </ProgressiveImage>
                );
            }
        }
    }

    render() {
        return (
            <div className={[styles.cardContainer, this.props.className].join(' ')}
                 onClick={this.props.onClick}>
                <div className={styles.content}>
                    <div className={[styles.imageContainer, this.props.imageClassName].join(' ')}>
                        {this.renderImage()}
                    </div>
                    <span className={["h4Bold", styles.title].join(' ')}>
                        {this.props.cardInfo.name}
                    </span>
                    <p className={styles.p}>{this.renderDistance()}</p>
                </div>
            </div>
        );
    }

}

export default PlaceCard;